import React from 'react'
import { SidebarCTABox, SidebarCTABoxHeader, SidebarCTABoxLink } from './SidebarCTABox'

function UpgradeToPremiumCTABox () {
  return (
    <SidebarCTABox>
      <SidebarCTABoxHeader>
        Contact Sales to upgrade your account and engage more government buyers.
      </SidebarCTABoxHeader>
      <SidebarCTABoxLink
        href='https://ratings.procurated.com/supplier_inquiry-0'
        text='Contact Sales'
      />
    </SidebarCTABox>
  )
}

export default UpgradeToPremiumCTABox
